export default "__VITE_ASSET__Bf7R6LFV__"